import { DialogLayoutModule } from '@tcc-mono/shared/ui/dialog-layout';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportGroupRvoResultDialogComponent } from './transport-group-rvo-result-dialog.component';
import { TranslocoModule } from '@ngneat/transloco';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    DialogLayoutModule,
    TranslocoModule,
    FontAwesomeModule
  ],
  declarations: [TransportGroupRvoResultDialogComponent],
  exports: [TransportGroupRvoResultDialogComponent]
})
export class TransportGroupRvoResultDialogModule { }
